import { SentimentSatisfiedAlt } from '@mui/icons-material';
import { Alert, AlertTitle, LinearProgress, Typography } from '@mui/material';
import * as React from 'react';
import { useState } from 'react';
import { useGetAlertas } from '../../hooks/alertas';
import AlumnosList from '../Alumnos/Alumnos';

export function Reportes() {
  const [open, setOpen] = useState<string | null>(null);

  const {
    deudores,
    faltadores,
    abandonadores,
    sinGrupo,
    faltanCuotas,
    hayAlerta,
    loading,
  } = useGetAlertas();

  if (
    loading ||
    !deudores ||
    !faltadores ||
    !abandonadores ||
    !sinGrupo ||
    !faltanCuotas ||
    !hayAlerta) return <LinearProgress />;

  return (
    <>
      {!!deudores.length && <div style={{ margin: 16, cursor: 'pointer' }}>
        <Alert severity="warning" onClick={() => open === 'deudores' ? setOpen(null) : setOpen('deudores')} >
          {`${deudores.length} ${deudores.length > 1 ? 'alumnos' : 'alumno'} con 3 o mas cuotas adeudadas`}
        </Alert>
        {open === 'deudores' && <AlumnosList filter={deudores.map((d) => d.dni)} />}
      </div>}
      {!!faltadores.length && <div style={{ margin: 16, cursor: 'pointer' }}>
        <Alert severity="warning" onClick={() => open === 'faltadores' ? setOpen(null) : setOpen('faltadores')} >
          {`${faltadores.length} ${faltadores.length > 1 ? 'alumnos faltaron' : 'alumno faltó'} las ultimas 4 clases`}
        </Alert>
        {open === 'faltadores' && <AlumnosList filter={faltadores.map((d) => d.dni)} />}
      </div>}
      {!!abandonadores.length && <div style={{ margin: 16, cursor: 'pointer', textAlign: 'left' }}>
        <Alert severity="error" onClick={() => open === 'abandonadores' ? setOpen(null) : setOpen('abandonadores')} >
          <AlertTitle>Potenciales abandonos</AlertTitle>
          {`${abandonadores.length} ${abandonadores.length > 1 ? 'alumnos faltaron' : 'alumno faltó'} las ultimas 4 clases y ademas
          ${abandonadores.length > 1 ? 'deben' : 'debe'} 3 o mas cuotas`}
        </Alert>
        {open === 'abandonadores' && <AlumnosList filter={abandonadores.map((d) => d.dni)} />}
      </div>}
      {!!sinGrupo.length && <div style={{ margin: 16, cursor: 'pointer' }}>
        <Alert severity="warning" onClick={() => open === 'sinGrupo' ? setOpen(null) : setOpen('sinGrupo')} >
          {`${sinGrupo.length} ${sinGrupo.length > 1 ? 'alumnos no tienen' : 'alumno no tiene'} grupo asignado`}
        </Alert>
        {open === 'sinGrupo' && <AlumnosList filter={sinGrupo.map((d) => d.dni)} />}
      </div>}
      {!!faltanCuotas?.length &&
      (<div style={{ margin: 16, cursor: 'pointer' }}>
        <Alert severity="error" style={{ textAlign: 'left' }} >
        Faltan cargar los valores de las cuotas de este mes o el mes próximo para los grupos:
          {faltanCuotas.map((c) => (
            <Typography>{`● ${c}`}</Typography>
          ))}
        </Alert>
        {open === 'sinGrupo' && <AlumnosList filter={sinGrupo.map((d) => d.dni)} />}
      </div>)}
      {!hayAlerta &&
      (<div style={{ margin: 16, cursor: 'pointer' }}>
        <Alert severity="success" >
          No hay alertas, parece que esta todo bajo control <SentimentSatisfiedAlt color="success" />
        </Alert>
        {open === 'sinGrupo' && <AlumnosList filter={sinGrupo.map((d) => d.dni)} />}
      </div>)}
    </>
  );
}
